import { RouteObject } from 'react-router-dom'
import HolidayList from './components/List'
import HolidayCreate from './components/Create'
import HolidayUpdate from './components/Update'
import createTour from './components/Create/Tour'
import { TourProvider } from '@/components/TourProvider'
import i18n from '@/configs/i18n'

const HolidayModule: RouteObject = {
    path: 'workdays/holiday',
    children: [
        {
            path: '',
            element: <HolidayList />,
        },
        {
            path: 'new',
            element: (
                <TourProvider steps={createTour(i18n.t)}>
                    <HolidayCreate />
                </TourProvider>
            ),
        },
        {
            path: ':holidayID',
            element: <HolidayUpdate />,
        },
    ],
}
export default HolidayModule
